import { ReactNode } from 'react';
import { CSSObjectWithLabel } from 'react-select';
import { DefaultTheme } from 'ui/selectv2/Themes';

export const MultiSelectInputTheme = (errorMsg?: ReactNode) => {
  const defaultTheme = DefaultTheme(errorMsg);
  return {
    ...defaultTheme,
    valueContainer: (baseStyles: CSSObjectWithLabel) => ({
      ...defaultTheme.valueContainer(baseStyles),
      paddingLeft: '14px',
    }),
    input: (baseStyles: CSSObjectWithLabel) => ({
      ...defaultTheme.input(baseStyles),
      gridTemplateColumns: '0 auto',
    }),
  };
};
